import CarpartsPlusWmo from '@usap/uicomponents/src/components/Icons/wmo-icons/CarpartsPlusWmo'
import React from 'react'
import styled from 'styled-components'
import useLoyaltyEnabled from '../../../../../../hooks/useLoyaltyEnabled'
import { CP_PLUS_GOLD_LOGO_URL, CP_PLUS_GOLD_LOGO_URL_SM } from '../../../../../FreeShippingBadge/constants'

const StyledContainer = styled.p`
  border-radius: 4px;
  background: #D4F4FF;
  height: 40px;
  width: 99px;
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 600;
  margin: 0 0 12px 0;
  text-align: center;
  line-height: 20px;
  padding-top: 2px;
`

const StyledContainerCarosuel = styled.div`
  border-radius: 4px;
  background: #D4F4FF;
  height: 28px;
  align-self: ${({ isCarousel }) => isCarousel ? 'auto' : 'stretch'};
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 10.5px;
  font-weight: 600;
  line-height: 7px;
  margin: 0 0 12px 0;
  text-align: center;
  padding-top: 2px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: .25rem;
  border-radius: .25rem;
  padding: 2px 4px;
`

const StyledBadgeIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 2,1rem;
`

const StyledGoldWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${({ isCarousel }) => isCarousel ? '4px' : '6px'};
  padding: ${({ isCarousel }) => isCarousel ? '0' : '3.5px 4px'};
`

const StyledGoldText = styled.div`
  display: flex;
  flex-direction: column;
  font-style: italic;
  font-weight: ${({ isCarousel }) => isCarousel ? 700 : 600};
  font-size: ${({ isCarousel }) => isCarousel ? '9px' : '10px'};
  line-height: 115%;
  letter-spacing: 0%;
  color: #111F30;

  > span {
    font-style: italic !important;
    font-weight: ${({ isCarousel }) => isCarousel ? 700 : 600} !important;
    font-size: ${({ isCarousel }) => isCarousel ? '9px' : '10px'} !important;
    line-height: 115% !important;
    letter-spacing: 0% !important;
  }
`

const FreeShippingMembership = ({ sku, isCarousel = false }) => {
  const isLoyaltyEnabled = useLoyaltyEnabled()

  if (isLoyaltyEnabled) {
    return (
      <StyledContainerCarosuel
        isCarousel={isCarousel}
        id={`free-shipping-membership-${sku}`}
        data-testid={isCarousel ? 'carousel-freeshipping-membership' : 'freeshipping-membership'}
      >
        <StyledGoldWrapper isCarousel={isCarousel}>
          <img src={isCarousel ? CP_PLUS_GOLD_LOGO_URL_SM : CP_PLUS_GOLD_LOGO_URL} width={isCarousel ? 18 : 20} height={isCarousel ? 18 : 20} alt="CarParts+ Gold" style={{ objectFit: 'contain', width: isCarousel ? '18px' : '20px', height: isCarousel ? '18px' : '20px', minHeight: 'unset', maxWidth: 'unset' }} />
          <StyledGoldText isCarousel={isCarousel}>
            <span>Ships Free with</span>
            <span>CarParts+ Gold</span>
          </StyledGoldText>
        </StyledGoldWrapper>
      </StyledContainerCarosuel>
    )
  }

  if (isCarousel) {
    return (
      <StyledContainerCarosuel
        isCarousel={isCarousel}
        id={`free-shipping-membership-${sku}`}
        data-testid="carousel-freeshipping-membership"
      >
        <div>Ships Free with</div>
        <StyledBadgeIconWrapper>
          <CarpartsPlusWmo width={58} height={12} viewBox="0 0 69 12" />
        </StyledBadgeIconWrapper>
      </StyledContainerCarosuel>
    )
  }

  return (
    <StyledContainer
      id={`free-shipping-membership-${sku}`}
      data-testid="freeshipping-membership"
    >
      Ships Free with
      <br />
      <CarpartsPlusWmo width={69} height={12} />
    </StyledContainer>
  )
}

export default FreeShippingMembership
